var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"float",attrs:{"href":"https://api.whatsapp.com/send?phone=14242530764&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n.","target":"_blank","rel":"noopener"}},[_c('i',{staticClass:"mdi mdi-whatsapp my-float"})])
}]

export { render, staticRenderFns }